
import LoadSimple from "../../LoadSimple";
import Modal from 'react-modal';
// import ModalDeleteBrand from "./ModalDeleteBrand";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
import ModalDeleteBuzon from "./ModalDeleteBuzon";
import InfoFolio from "./InfoFolio";
import ModalHostList from "./ModalHostLis";
const hostListModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "90%",
    padding: "20px",
  },
};
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'30%',
    height:'20%',
    padding:'20px'
  },
};
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "95%",
    padding: "20px",
  },
};
const deleteBuzonModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#ffffff !important',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'40%',
      height:'30%',
      padding:'20px'
    },
  };
const CatalogMedicionesList = ({
  pageActual,
  limitList,startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  cisSelected,
  setCisSelected,
  languaje,
  mode,
  rowSelected,
  poolRows,
  handleShowPopup,
  buscar_cis,
  loadingList,
}) => {
  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  const [hostsModalOpen, setHostsModalOpen] =useState(false);
  function openHostsModal() {
  //    setCisSelectedAux(elemento);
      setHostsModalOpen(true);
    }

  function closHostsModal() {
    
    setHostsModalOpen(false);
  }
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
        
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };

  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };

  function parseCommentHistory(texto) {
    const regex =
      /Usuario\s+\((.*?)\):\s*(.*?)\s*Fecha:\s*(.*?)\s*Comentario:\s*(.*?)(?=\n\n|$)/gs;
    const resultados = [];
    let match;

    while ((match = regex.exec(texto)) !== null) {
      resultados.push({
        tipo: match[1].trim(),
        usuario: match[2].trim(),
        fecha: match[3].trim(),
        comentario: match[4].trim(),
      });
    }

    return resultados;
  }

  const parsedData = dataList
  const statusWF={
    'PENDING':'var(--yellow-low)',
    'IN_PROCESS':'var(--green-low)',
    'FINALIZED':'var(--hover-color)',
    'REJECTED':'var(--red-alert)',
    'CANCELLED':'var(--hover-color)',
    'PENDING_AUTHORIZATION':'var(--yellow-low)',
  }
  const statustext={
   'IN_PROCESS':'#fff',
    'PENDING':'var(--text-color)',
    'FINALIZED':'var(--green)',
     'REJECTED':'#fff',
      'CANCELLED':'var(--red-alert)',
      'PENDING_AUTHORIZATION':'var(--text-color)',
  }
  const txtWF={
    'IN_PROCESS':'En Proceso',
    'PENDING':'Pendiente',
    'FINALIZED':'Finalizado',
     'REJECTED':'Rechazado',
      'CANCELLED':'Cancelado',
      'PENDING_AUTHORIZATION':'Pendiente de Autorización',
  }
  const [auth,setAuth]=useState(false)
  const [deleteBuzonModalOpen, setdeleteBuzonModalOpen] =useState(false);
  function openDeleteUserModal() {
        setdeleteBuzonModalOpen(true);
      }

  function closDeleteBuzonModal() {
    setdeleteBuzonModalOpen(false);
  }
  const handleActionResponse = (data) => {
          openHostsModal()
          setUserSelected(data)
          // Realiza las acciones deseadas al hacer clic en el marcador
        };
  const [source,setSource]=useState('')
  const [hostsListModalOpen, setHostsListModalOpen] =useState(false);
  const [cisView,setCisView]=useState({})
  function openHostsListModal() {
setHostsListModalOpen(true);
}

  function closHostsListModal() {
    
    setHostsListModalOpen(false);
  }
  const handleHostLisClick = (data,source) => {
setSource(source)
openHostsListModal()
setCisView(data)
// Realiza las acciones deseadas al hacer clic en el marcador
};
  return (
    <>
      <div className="cont-row-user-list">
        {loadingList ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          parsedData
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode}
                key={indice}
                style={{height:'45px'}}
              >
                 
                <div className="field-body-table-mantenimiento field-small">
                  {elemento.id}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'12%'}}>
                  {elemento.requester_user}
                </div>
                <div className="field-body-table-mantenimiento field-larger"  style={{width:'10%'}}>
                  {elemento.created_at.replace('T',' ')}
                </div>
                <div className="field-body-table-mantenimiento field-medium" style={{width:'16%'}}>
                  {(elemento.auth_decision_at==null)?'N/A':elemento.auth_decision_at.replace('T',' ')}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'10%'}}>
                  {elemento.in_process_at==null?'N/A':elemento.in_process_at.replace('T',' ')}
                </div>
                <div className="field-body-table-mantenimiento field-larger"  style={{width:'10%'}}>
                  {elemento.finalized_at==null?'N/A':elemento.finalized_at.replace('T',' ')}
                </div>
                <div className="field-body-table-mantenimiento field-medium"style={{width:'10%'}}>
                  {elemento.cancelled_at==null?'N/A':elemento.cancelled_at.replace('T',' ')}
                </div>
                <div className="field-body-table-mantenimiento field-medium fieldWFstatus"style={{width:'5%'}}>
                  <div style={{width:'35%'}} className="infoWFerror">
                  <img
                    src={
                      "/iconos/review.png"
                    } 
                    onClick={()=>handleHostLisClick(elemento,'disconnected_hosts')}
                    name="Ver"  title='Ver' className="btnAction delteException" style={{width:'65%'}}
                  />
                  </div>
                  {elemento.total_details_count}
                </div>
                <div className="field-body-table-mantenimiento field-medium" style={{width:'10%'}}>
                   <div className="tagIpAvailable" style={{background: statusWF[elemento.status],border:'1px solid '+statusWF[elemento.status],color:statustext[elemento.status]}}>
                  {txtWF[elemento.status]}
                  </div>
                </div>
                <div className="field-body-table-mantenimiento field-medium" style={{width:'10%'}}>
                   
                <div className='cont-img-field-acciones' >
                  <img className='img-field-acciones'style={{width:'50%'}} src='/iconos/review.png' title='Ver'name='Cancelar' ci_id={elemento.mail_id} onClick={(e)=> {e.stopPropagation(); handleActionResponse(elemento)}} />
                </div>
                </div>
                
                {/* <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.item_name}
                </div>
                <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.template_name}
                </div> */}
                
                
                
                
              </div>
            ))
        )}
        { dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      {/* <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalDeleteBrand  handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteBrand>
    </Modal> */}
    <Modal
        isOpen={deleteBuzonModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteBuzonModal}
        style={deleteBuzonModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalDeleteBuzon  buscar_cis={buscar_cis} handleActionResponse={handleActionResponse} ShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}  auth={auth} setRegisterIsValid ={setRegisterIsValid } setData={setData} setLoading={setLoading} setError={setError} Buzon={userSelected} closDeleteBuzonModal={closDeleteBuzonModal}></ModalDeleteBuzon>
    </Modal>
     <Modal
        isOpen={hostsModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closHostsModal}
        style={hostListModalSyncStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <InfoFolio    server={server}languaje={languaje} cisData={userSelected} closHostsModal={closHostsModal}></InfoFolio>
    </Modal>
    <Modal
        isOpen={hostsListModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closHostsListModal}
        style={hostListModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalHostList  source ={source} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode}  server={server} setData={setData} setLoading={setLoading} setError={setError} brand={cisView} closHostsListModal={closHostsListModal}></ModalHostList>
    </Modal>
    </>
  );
};

export default CatalogMedicionesList;
